import { apiFetch } from './client';
import type {
  EstadoCuentaResponse,
  LoteResumen,
  RecursoConSuspensionRead,
  VehiculoRead,
} from './types';

export function getEstadoCuenta(loteId: string): Promise<EstadoCuentaResponse> {
  return apiFetch<EstadoCuentaResponse>(`/lotes/${loteId}/estado-cuenta`);
}

// Sprint 18 P7 — historial lote-céntrico (derivado on-read).
export interface EventoHistorial {
  fecha: string; // YYYY-MM-DD
  tipo: string;
  descripcion: string;
}

/** Historial del vecino (recortado a su tenencia). */
export function getHistorialLote(loteId: string): Promise<EventoHistorial[]> {
  return apiFetch<EventoHistorial[]>(`/lotes/${loteId}/historial`);
}

/** Historial completo del lote (comisión). */
export function getHistorialLoteCompleto(
  loteId: string,
): Promise<EventoHistorial[]> {
  return apiFetch<EventoHistorial[]>(`/lotes/${loteId}/historial-completo`);
}

export function listarLotes(soloActivos = true): Promise<LoteResumen[]> {
  const query = soloActivos ? '?activo=true' : '';
  return apiFetch<LoteResumen[]>(`/lotes/${query}`);
}

// Alias con firma de objeto (Sprint 13 S13-04, migrado desde
// frontend-superadmin). Mantiene compatibilidad con codigo migrado
// sin tener que reescribir cada caller.
export function listLotes(opts: { activo?: boolean } = {}): Promise<LoteResumen[]> {
  const params = new URLSearchParams();
  if (opts.activo !== undefined) params.set('activo', String(opts.activo));
  const qs = params.toString();
  return apiFetch<LoteResumen[]>(`/lotes/${qs ? `?${qs}` : ''}`);
}

export function listarRecursosDeLote(
  loteId: string,
): Promise<RecursoConSuspensionRead[]> {
  return apiFetch<RecursoConSuspensionRead[]>(`/lotes/${loteId}/recursos`);
}

// Sprint 12 S12-11.
export function listarVehiculosDeLote(loteId: string): Promise<VehiculoRead[]> {
  return apiFetch<VehiculoRead[]>(`/lotes/${loteId}/vehiculos`);
}

export interface CupoControlRemoto {
  cr_activos: number;
  max_controles_por_lote: number;
  /** Si la casa puede recibir un CR más (no está en el tope configurado). */
  puede_solicitar_cr: boolean;
}

export function getCupoControlRemoto(
  loteId: string,
): Promise<CupoControlRemoto> {
  return apiFetch<CupoControlRemoto>(`/lotes/${loteId}/cupo-control-remoto`);
}
